import { createUserManager } from 'redux-oidc';

const userManagerConfig = {
    client_id: 'woClient',
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`,
    response_type: 'token id_token',
    scope: 'openid profile WOAPI AdminAPI UserInfo',
    authority: 'https://idp.bosa.uat99.com',
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silent_renew.html`,
    automaticSilentRenew: false,
    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: false
}

const userManager = createUserManager(userManagerConfig);

export default userManager;